import { render } from "./EmptyTableState.vue?vue&type=template&id=0fb6412a&scoped=true"
import script from "./EmptyTableState.vue?vue&type=script&lang=js"
export * from "./EmptyTableState.vue?vue&type=script&lang=js"

import "./EmptyTableState.vue?vue&type=style&index=0&id=0fb6412a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb6412a"]])

export default __exports__